import React, { Component } from 'react';
import success from '../assets/Images/Success_Check.png';

class VerifySuccess extends Component {

  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className ="max-width-20 position-center margin-center">
              <img src={success} className="margin-bottom-2 position-center" alt="success" />
              <h1 className="text-bold margin-top-1"> Your request is confirmed! </h1>
              <p className="margin-top-2 font-size-14">We will review your request and contact you shortly.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VerifySuccess;
